import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import { sendAnalyticsEvents } from '../../analytics/common'
import { EVENTS } from '../../analytics/events'
import { selectEventsData } from '../events/eventsSlice'
import { appendLink } from '../../helper/utils'
import MainHeadline from '../../UI/MainHeadline'
import MainDescription from '../../UI/MainDescription'
import UIButton from '../../UI/UIButton'


const Wrapper = styled.div`
    background: linear-gradient(180deg, rgba(255,241,232,1) 0, rgba(255,241,232,1) 50%, rgba(255,241,232,0) 100%);
    border-radius: 48px;
    flex-grow: 1;
    max-height: 500px;
    padding-top: 24px;
    display: flex;
    flex-direction: column;
`;

const FeatureImg = styled.div`
    flex-grow: 1;
    position: relative;
    margin-top: 35px;
    
    &:after {
        content: '';
        display: block;
        width: 100%;
        height: 100%;
        border-radius: 0 0 48px 48px;
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        ${({pageName}) => pageName && `background: url(../assets/screens/${pageName}.png) center bottom / contain no-repeat;`}
    }
`;

const FeaturesContainer = ({ history, pageName, nextUrl, pageEvent, clickEvent }) => {
    const {t} = useTranslation();
    const eventsData = useSelector(selectEventsData);

    useEffect(() => {
        const image = (nextUrl === 'choose-your-target')
            ? '../assets/checkmark-circle.svg'
            : `../assets/screens/${nextUrl}.png`;

        appendLink(image);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    useEffect(() => sendAnalyticsEvents(EVENTS[pageEvent], eventsData), [pageEvent,eventsData]);

    const onContinueClick = () => {
        sendAnalyticsEvents(EVENTS[clickEvent], eventsData);
        history.push(nextUrl)
    };

    return (
        <>
            <Wrapper>
                <MainHeadline>{t(pageName)}</MainHeadline>
                <MainDescription>{t(`${pageName}_description`)}</MainDescription>
                <FeatureImg pageName={pageName}/>
            </Wrapper>
            <UIButton onClick={onContinueClick} customMargin={'30px 0 0'} />
        </>
    )
};

export default FeaturesContainer
